import React, { useState, useEffect, useContext } from "react";
import Dialog from "@mui/material/Dialog";
import Grid from "@mui/material/Grid";
import { APIContext } from "../../Contexts/APIContext";
import Paper from "@mui/material/Paper";
import QaiScorecardChallengeNoteViewModel from "./ViewModels/QaiScorecardChallengeNoteViewModel";
import GetChallengeNoteViewModel from "./ViewModels/GetChallengeNoteViewModel";
import AgentQaiChallengeNotes from "./AgentQaiChallengeNotes";
import QaiChallengePageHeader from "./QaiChallengePageHeader";
import AgentQaiChallengeNotesHeader from "./AgentQaiChallengeNotesHeader";
import QaiChallengeNotesHeader from "./QaiChallengeNotesHeader";
import QaiChallengeNotes from "./QaiChallengeNotes";
import QaiChallengeAddNote from "./QaiChallengeAddNote";
import QaiChallengeSubmitButtons from "./QaiChallengeSubmitButtons";
import QaiChallengeFilterViewModel from "./ViewModels/QaiChallengeFilterViewModel";
import { QaiScorecardChallengeQuestionViewModel } from "./ViewModels/QaiScorecardChallengeQuestionsViewModel";
import getActiveFilterDateRangeFlag from "../../Utilities/DateRange";

interface IQaiChallengePageProps {
    openDialog: boolean
    handleChallengeClose: () => void
    questionViewModel: QaiScorecardChallengeQuestionViewModel
    filters: QaiChallengeFilterViewModel
    view: string
    getChallengedQuestions: () => void
}

export default function QaiChallengePage({ openDialog, handleChallengeClose, questionViewModel, filters, view, getChallengedQuestions }: IQaiChallengePageProps) {
    const { get } = useContext(APIContext);
    const [noteViewModel, setNoteViewModel] = useState<QaiScorecardChallengeNoteViewModel>(
        new QaiScorecardChallengeNoteViewModel(questionViewModel.questionId, questionViewModel.aiTemplateVersion));
    const [notesViewModel, setNotesViewModel] = useState<GetChallengeNoteViewModel[]>([]);
    const [challengeCount, setChallengeCount] = useState<number | null>(null);

    useEffect(() => {
        getChallengeNotes();
        getChallengeCount();
    }, [])

    const getChallengeNotes = () => {
        get('QaiScorecardChallenge',
            `GetChallengeNotes?questionId=${questionViewModel.questionId}&aiVersionTemplate=${questionViewModel.aiTemplateVersion}`,
            (data) => setNotesViewModel(data));
    }

    const getChallengeCount = () => {
        get('QaiScorecardChallenge',
            `GetChallengeCount?questionId=${questionViewModel.questionId}&aiVersionTemplate=${questionViewModel.aiTemplateVersion}&dateRangeFlag=${getActiveFilterDateRangeFlag(filters)}`,
            (data) => setChallengeCount(data));
    }

    return (
        <Dialog
            open={openDialog}
            fullScreen
            PaperProps={{ sx: { padding: 0 } }}
        >
            <QaiChallengePageHeader
                handleChallengeClose={handleChallengeClose}
                questionViewModel={questionViewModel}
                filters={filters} />
            <Grid
                container
                height="93%"
                justifyContent="space-between"
                sx={{ backgroundColor: 'rgb(245, 245, 245)' }}>
                <Grid container size={6} height="100%">
                    <Paper sx={{ height: '100%', width: '100%' }}>
                        <AgentQaiChallengeNotesHeader questionViewModel={questionViewModel} filters={filters} challengeCount={challengeCount} />
                        <AgentQaiChallengeNotes
                            view={view}
                            question={questionViewModel}
                            filters={filters}
                            getChallengeCount={getChallengeCount}
                            getChallengedQuestions={getChallengedQuestions} />
                    </Paper>
                </Grid>
                <Grid size={6} height="100%">
                    <Paper sx={{ height: '100%', width: '100%' }}>
                        <QaiChallengeNotesHeader questionViewModel={questionViewModel} filters={filters} />
                        <QaiChallengeNotes view={view} notesViewModel={notesViewModel} getChallengeNotes={getChallengeNotes} />
                        <QaiChallengeAddNote noteViewModel={noteViewModel} setNoteViewModel={setNoteViewModel} />
                        <QaiChallengeSubmitButtons
                            noteViewModel={noteViewModel}
                            notesViewModel={notesViewModel}
                            setNoteViewModel={setNoteViewModel}
                            getChallengeNotes={getChallengeNotes}
                            view={view} />
                    </Paper>
                </Grid>
            </Grid >
        </Dialog >
    )
}